/**
 * Canonical form for matching router URLs to `TabItem.route` (NavigationEnd urlAfterRedirects).
 * Sorts query keys so cache lookups stay stable regardless of param order.
 */
export function normalizeTabRouteKey(url: string): string {
    const trimmed = url.trim();
    const qIdx = trimmed.indexOf('?');
    if (qIdx === -1) {
        const p = trimmed.length > 0 ? trimmed : '/';
        return p.startsWith('/') ? p : `/${p}`;
    }
    const pathPart = trimmed.slice(0, qIdx);
    const queryPart = trimmed.slice(qIdx + 1);
    const path = pathPart.length > 0 ? pathPart : '/';
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    const params = new URLSearchParams(queryPart);
    const keys = [...params.keys()].sort();
    if (keys.length === 0) {
        return normalizedPath;
    }
    const qs = keys
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params.get(k) ?? '')}`)
        .join('&');
    return `${normalizedPath}?${qs}`;
}
